<template>
    <div id="modal-create-tag">
        <div class="rp-modal" style="width: 470px;">
            <div class="rp-modal-header">
                <h3 class="rp-modal-title">{{ $t('Confirm delete') }}</h3>
                <button class="rp-btn-dismiss" @click="$emit('closeModal')">
                    <XIcon class="w-5 h-5" />
                </button>
            </div>
            <div class="bg-white p-5">
                <div class="mb-4">
                    <div class="flex flex-col gap-1">
                        <p class="text-sm">
                            {{ $t('To confirm deletion, please type the tag ID') }} 
                            <b>{{ layout.currentTag.id }}</b>
                        </p>
                        <div class="text-xs font-medium">{{ $t('This will delete all image annotations with this tag') }}</div>
                        <input type="text" class="form-control border-transparent mt-4 py-3 px-4 pr-10 bg-gray-200 text-gray-700" 
                            :placeholder="'Type tag ID'" v-model="layout.inputTagName" required />
                        <div v-if="showError" class="text-xs font-medium mt-2 text-red-600">
                            {{ $t('The tag ID does not match') }}
                        </div>
                    </div>
                </div>
                <div class="rp-modal-body-buttons gap-3 mt-4">
                    <button class="rp-btn-secondary" @click="$emit('closeModal')">
                        {{ $t('Cancel') }}
                    </button>
                    <button class="rp-btn-danger" @click="deleteTag()"
                        :disabled="!enableDeleteButton">
                        {{ $t('Delete') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, computed, ref } from "vue";
import * as rosepetalModel	        from "rosepetal-model";

let $dataset = rosepetalModel.default.dataset;

const emit = defineEmits(['closeModal, tagCreated']);

const props = defineProps({
    dataset: {
        type: Object,
        required: true,
    },
    currentTag: {
        type: Object,
        required: true,
    }
});

const layout = ref({
    dataset:        {},
    currentTag:     {},
    inputTagName:   ''
});

const showError = computed(() => {
    return layout.value.inputTagName !== layout.value.currentTag.id && layout.value.inputTagName.length > 0;
});

const enableDeleteButton = computed(() => {
    return layout.value.currentTag.id === layout.value.inputTagName;
});

const deleteTag = async () => { 
	await $dataset.deleteTag(layout.value.dataset, layout.value.currentTag);
	emit("tagDeleted");
}

onMounted(() => {
    if (props.dataset) {
        layout.value.dataset = props.dataset;
    }
    if (props.currentTag) {
        layout.value.currentTag = props.currentTag;
    }
});
</script>